import React, { useEffect, useState, ReactElement } from "react"
import _ from "lodash"

type Position = "-top-left" | "-top-right" | "-bottom-left" | "-bottom-right"

interface StickyButton {
  children: ReactElement
  position: Position
  showAtPercentage: number | null | undefined
}

const StickyButton = (props: StickyButton) => {
  const [isVisible, setIsVisible] = useState(false)

  // Show button when page is scrolled to given distance
  const toggleVisibility = () => {
    if (props.showAtPercentage) {
      const scrollPercentage = calculateScrollPercentage()
      const isVisible =
        scrollPercentage && scrollPercentage > props.showAtPercentage
          ? true
          : false
      setIsVisible(isVisible)
    } else {
      setIsVisible(window.pageYOffset > 300)
    }
  }

  const calculateScrollPercentage = () => {
    if (window && document) {
      const scrollTop = window.scrollY
      const docHeight = document.body.offsetHeight
      const winHeight = window.innerHeight
      const scrollPercent = scrollTop / (docHeight - winHeight)
      return Math.round(scrollPercent * 100)
    }
  }

  const throttledToggleVisibility = _.throttle(toggleVisibility, 200)

  useEffect(() => {
    window.addEventListener("scroll", throttledToggleVisibility)
    return () => {
      window.removeEventListener("scroll", throttledToggleVisibility)
    }
  }, [])

  return (
    <div
      className={`c-sticky-button ${props.position}  ${
        isVisible ? "" : "-hidden"
      }`}
    >
      {props.children}
    </div>
  )
}

export default StickyButton
